import { Lightning } from "@lightningjs/sdk";
import { ProgressBar } from "@lightningjs/ui-components";

export default class CustomProgressBar extends ProgressBar {

    override _construct() {
        super._construct && super._construct();    
    }

    override _updateProgress() {
        //do not smooth.
        // const w = this._getProgressWidth();

        // this._Progress.smooth = {
        //     w: [w, this.style.animation],
        //     alpha: Number(w > 0)
        // };
    }

    override _updateTextures() {
        const maxW = this.w - 2;
        const radius = this.getMaxRoundRadius(this.style.radius, maxW, this.h);

        // 1. Draw the background bar texture ONCE if it doesn't exist
        if (!this._Bar.texture) {
            this._Bar.texture = Lightning.Tools.getRoundRect(
                maxW,
                this.h,
                radius,
                0,
                0,
                true,
                this.style.barColor
            );
        }

        // 2. Draw the full-size progress texture ONCE if it doesn't exist
        if (!this._Progress.texture) {
            this._Progress.texture = Lightning.Tools.getRoundRect(
                maxW, // Use the MAXIMUM width here, not the dynamic progress width
                this.h,
                radius,
                0,
                0,
                true,
                this.style.progressColor
            );
        }

        // 3. Dynamically slice the texture using clipping (REUSES SAME CANVAS/GPU TEXTURE)
        const currentW = this._getProgressWidth();

        // Update the element visual width
        this._Progress.w = currentW;
        this._Progress.alpha = currentW > 0 ? 1 : 0

        // Clip the texture so the rounded corner doesn't stretch
        this._Progress.texture?.clipping = [0, 0, currentW, this.h];
    }

    getMaxRoundRadius(radius: number, width: number, height: number, offset = 0) {
        const maxRadius = (r: Number) =>
            Math.max(0, Math.min(r, Math.min(width, height) / 2) + offset);
        return Array.isArray(radius)
            ? radius.map(r => Number(maxRadius(r)) || 0)
            : Number(maxRadius(radius)) || 0;
    }
}